// Shared by the build and browser. Only public build-time values belong here.
function resolveAccountsConfig(env) {
  const enabled = env.REACT_APP_ACCOUNTS_V1_ENABLED === 'true';
  const environment = env.REACT_APP_ENVIRONMENT || (env.NODE_ENV === 'production' ? 'production' : 'local');
  if (!['local', 'staging', 'production', 'c3c'].includes(environment)) {
    throw new Error('Invalid public Accounts environment');
  }
  if (!enabled) return { enabled: false, environment, apiBaseUrl: '' };
  let api, frontend;
  try {
    api = new URL(env.REACT_APP_ACCOUNTS_API_URL);
    if (['staging', 'c3c', 'production'].includes(environment)) frontend = new URL(env.REACT_APP_ACCOUNTS_FRONTEND_ORIGIN);
  } catch {
    throw new Error('Accounts ON requires an explicit valid API URL and staging frontend origin');
  }
  if (api.username || api.password || api.search || api.hash || !['http:', 'https:'].includes(api.protocol)) {
    throw new Error('Invalid public Accounts API URL');
  }
  if (environment === 'local') {
    if (!['localhost', '127.0.0.1', '[::1]'].includes(api.hostname) || api.pathname !== '/') {
      throw new Error('Local Accounts must use an explicit loopback API origin');
    }
  } else if (api.protocol !== 'https:' || frontend.protocol !== 'https:' ||
      frontend.username || frontend.password || frontend.search || frontend.hash || frontend.pathname !== '/' ||
      ['localhost', '127.0.0.1', '[::1]'].includes(api.hostname) ||
      api.origin !== frontend.origin || api.pathname.replace(/\/$/, '') !== '/accounts-api') {
    throw new Error('Staging Accounts requires HTTPS same-origin /accounts-api routing');
  }
  if (environment === 'c3c' && api.origin !== 'https://technomath-c3c-sandbox.netlify.app') {
    throw new Error('C3C requires its isolated frontend origin');
  }
  if (environment === 'production' &&
      (frontend.port || /(^|[.-])(localhost|staging|sandbox|dev)([.-]|$)/.test(frontend.hostname) ||
       env.REACT_APP_PAYPAL_C3C_ENABLED === 'true')) {
    throw new Error('Production Accounts requires its independent HTTPS origin, without Sandbox capabilities');
  }
  return { enabled, environment, apiBaseUrl: api.href.replace(/\/$/, '') };
}
function validateAccountsRuntimeOrigin(config, origin) {
  if (config.enabled && ['staging', 'c3c', 'production'].includes(config.environment) && new URL(config.apiBaseUrl).origin !== origin) {
    throw new Error('Staging Accounts artifact is served from an unexpected origin');
  }
}
function resolveCommercialControl(env) {
  if (env.REACT_APP_ACCOUNTS_COMMERCIAL_ENABLED !== 'true') return false;
  const config = resolveAccountsConfig(env);
  if (!config.enabled || !['local', 'c3c', 'production'].includes(config.environment)) {
    throw new Error('Commercial play requires explicit local or isolated C3C Accounts; staging remains disabled');
  }
  if (config.environment === 'c3c' && env.REACT_APP_PAYPAL_C3C_ENABLED !== 'true') {
    throw new Error('C3C commercial play requires explicit Sandbox checkout configuration');
  }
  return true;
}
function resolveSandboxCheckout(env) {
  if (env.REACT_APP_PAYPAL_C3C_ENABLED !== 'true') return false;
  const config = resolveAccountsConfig(env);
  if (!config.enabled || config.environment !== 'c3c') throw new Error('Sandbox checkout requires C3C');
  return true;
}
function resolveLiveCheckout(env) {
  if (env.REACT_APP_PAYPAL_LIVE_CHECKOUT_ENABLED !== 'true') return false;
  const config = resolveAccountsConfig(env);
  if (!config.enabled || config.environment !== 'production' || env.REACT_APP_PAYPAL_C3C_ENABLED === 'true' ||
      env.REACT_APP_ACCOUNTS_COMMERCIAL_ENABLED !== 'true') {
    throw new Error('Live checkout requires independent production Accounts');
  }
  return true;
}
module.exports = { resolveLiveCheckout, resolveAccountsConfig, validateAccountsRuntimeOrigin, resolveCommercialControl, resolveSandboxCheckout };



